import { useEffect, useState } from "react"
import { useActions } from "../../../hooks/useActions"
import RtMultipleSelect from "../../../ui/RtMultipleSelect"
import { Button, message, Space } from "antd"
import { ApiCustomFilter } from "../api/filterApi"
import { multipleSelectOptions } from "../../../types/settings"
import { getProfileId } from "../../../helper/profileId.helper"

interface ICustomerFiltersProps {
  setSelectCustomFilters: React.Dispatch<React.SetStateAction<string[]>>
  setSelectedCampaignIds: React.Dispatch<React.SetStateAction<number[]>>
}

const CustomFilters: React.FC<ICustomerFiltersProps> = ({
  setSelectCustomFilters,
  setSelectedCampaignIds,
}) => {
  const [optionName, setOptionName] = useState<multipleSelectOptions[]>([])
  const [loadFailed, setLoadFailed] = useState<boolean>(false)
  const { setExpandableCampaignIds } = useActions()
  const [selectedOption, setSelectedOption] = useState<string[]>([])

  const handleSelectAllFilter = (selectedList) => {
    setSelectedOption(selectedList)
  }

  const filterApply = () => {
    setExpandableCampaignIds([])
    setSelectedCampaignIds([])

    setSelectCustomFilters(selectedOption)
  }

  async function loadFilters() {
    try {
      const res = await ApiCustomFilter({ profileId: getProfileId() })
      setOptionName(
        res.data.map((el) => ({
          value: el._id,
          label: el.filterName,
        }))
      )
      setLoadFailed(false)
    } catch (_e) {
      setLoadFailed(true)
      message.error("Failed to load custom filters")
    }
  }

  useEffect(() => {
    loadFilters()
  }, [])

  return (
    <Space.Compact>
      <RtMultipleSelect
        onChange={handleSelectAllFilter}
        options={optionName}
        placeholder={"Custom settings"}
      />
      {loadFailed && <Button onClick={() => loadFilters()}>Retry</Button>}
      <Button onClick={() => filterApply()}>Apply</Button>
    </Space.Compact>
  )
}

export default CustomFilters
